import { IsString, MaxLength } from 'class-validator';

export class ResourceGroupSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
